import { apiStoreLenses } from 'root/src/client/logic/api/lenses'
import currentRouteParamsRecordId
	from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

const { viewUserCampaignDataChild } = apiStoreLenses

export default state => viewUserCampaignDataChild(currentRouteParamsRecordId(state), state)
